//import "@fancyapps/fancybox"

export async function initFancybox() {
    if($('[data-fancybox]').length){
        await import(/* webpackChunkName: "fancybox"*/ "@fancyapps/fancybox");
        $('[data-fancybox]').fancybox({
            touch: false,
        });
    }
    
}